import Link from "next/link";
import { useContext, useEffect, useState } from "react";
import { Button, Dropdown, DropdownHeader } from "react-bootstrap";
import AppContext from "./AppContext";
import notificationModel from "../models/notification.model";
import { useRouter } from "next/router";
import helper from "../lib/helper";

export default function Navbar({ children }) {
  const themeContext = useContext(AppContext);
  const router = useRouter();
  const queryParams = router.query;

  const [notificationData, setNotificationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalNotifications, setTotalNotifications] = useState(0);

  const logoutAction = async () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    window.location.assign("/login");
  };

  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const res = await notificationModel.list({
        ...queryParams,
        limit: 5,
      });

      setNotificationData(res?.data || []);
      setTotalNotifications(res?.meta?.total || 0);
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const markasread = async (id) => {
    await notificationModel.read_at(id).then(() => {
      // remove the clicked notification from state
      setNotificationData((prev) => prev.filter((n) => n.id !== id));

      // decrement total count

      helper.sweetalert.toast(`Marked as read successfully`);
      fetchNotifications()
    });
  };
  return (
    <nav className="sb-topnav navbar navbar-expand navbar-light bg-light shadow">
      <Link className="navbar-brand p-3" href="/">
        Pinknblu
      </Link>

      <button
        className="btn order-1 order-lg-0"
        onClick={() =>
          themeContext.setSidebarStatus(!themeContext.sidebarStatus)
        }
      >
        <i className="bi bi-list fs-4"></i>
      </button>

      {/* Notifications */}
      <Dropdown className="ms-auto me-3">
        <Dropdown.Toggle
          className="btn bg-transparent position-relative border-0"
          variant="light"
          size="sm"
        >
          <i className="bi bi-bell fs-5"></i>
          {totalNotifications > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              {totalNotifications}
            </span>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu
          className="shadow rounded-3 border-0 p-2"
          style={{ maxHeight: "320px", overflowY: "auto", minWidth: "320px" }}
        >
          <DropdownHeader className="fw-bold text-center text-primary border-bottom pb-2">
            Notifications
          </DropdownHeader>

          {isLoading ? (
            <Dropdown.Item disabled className="text-muted">
              Loading...
            </Dropdown.Item>
          ) : notificationData?.length ? (
            <>
             {notificationData.map((n, idx) => {
  if (n.read_at !== null) return null; // skip already read notifications

  const fullText = n?.data?.error || "";
  const isLong = fullText.length > 100;
  const snippet = isLong ? fullText.slice(0, 100) + "..." : fullText;

  return (
    <Dropdown.Item
      key={`navbar-notification-${idx}`}
      href="#!"
      className="rounded-2 mb-1 p-2"
    >
      <div className="d-flex align-items-start">
        <i className="bi bi-bell-fill text-warning me-2 mt-1"></i>

        <div
          className="text-wrap small"
          onClick={() => window.alert(fullText)}
        >
          {snippet}
        </div>
        <Button
          className="btn btn-outline-white btn-sm py-0 px-2"
          onClick={() => markasread(n?.id)}
        >
          Mark as read
        </Button>
      </div>
    </Dropdown.Item>
  );
})}

              {totalNotifications > 5 && (
                <Dropdown.Item
                  href="/notifications"
                  className="text-center fw-semibold text-primary mt-2"
                >
                  View all
                </Dropdown.Item>
              )}
            </>
          ) : (
            <Dropdown.Item disabled className="text-muted">
              No notifications
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {/* Profile */}
      <Dropdown>
        <Dropdown.Toggle
          className="btn bg-transparent border-0"
          variant="light"
          size="sm"
        >
          <i className="bi bi-person-circle fs-5"></i>
        </Dropdown.Toggle>

        <Dropdown.Menu className="shadow rounded-3 border-0 p-2">
          <Dropdown.Item
            key="navbar-profile"
            href="/profile"
            className="d-flex align-items-center gap-2 rounded-2 p-2"
          >
            <i className="bi bi-person-circle"></i> Profile
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            key="navbar-logout"
            onClick={logoutAction}
            className="d-flex align-items-center gap-2 text-danger rounded-2 p-2"
          >
            <i className="bi bi-box-arrow-left"></i> Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </nav>
  );
}
